import { render, staticRenderFns } from "./CallContact.vue?vue&type=template&id=00d32085&scoped=true&"
import script from "./CallContact.vue?vue&type=script&lang=js&"
export * from "./CallContact.vue?vue&type=script&lang=js&"
import style0 from "./CallContact.vue?vue&type=style&index=0&id=00d32085&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d32085",
  null
  
)

export default component.exports